import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, createVNode as _createVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center w-full" }
const _hoisted_2 = { class: "cursor-pointer" }
const _hoisted_3 = { class: "text-black pr-1 text-xs" }
const _hoisted_4 = {
  key: 1,
  class: "inline-block w-24 h-4 bg-gray-100 animate-pulse rounded"
}
const _hoisted_5 = { class: "flex justify-center items-center w-6" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "relative bg-gray-100 p-0.5 rounded-lg flex shadow-inner text-[10px] h-6 w-24" }
const _hoisted_8 = ["data-match", "data-key", "onClick"]
const _hoisted_9 = {
  key: 0,
  class: "relative mx-auto w-16 h-16"
}
const _hoisted_10 = ["src", "title", "alt"]
const _hoisted_11 = { class: "text-xs text-center w-16 pt-1" }
const _hoisted_12 = {
  key: 1,
  class: "relative mx-auto z-20 w-20"
}
const _hoisted_13 = ["src", "title", "alt"]
const _hoisted_14 = {
  key: 2,
  class: "relative mx-auto z-20 w-20"
}
const _hoisted_15 = ["src", "title", "alt"]
const _hoisted_16 = { class: "text-xs text-center w-20 pt-1" }
const _hoisted_17 = {
  key: 0,
  class: "mx-auto"
}
const _hoisted_18 = {
  key: 0,
  class: "w-full text-xs text-center px-2 pt-2"
}
const _hoisted_19 = {
  key: 1,
  class: "mx-auto"
}
const _hoisted_20 = {
  key: 0,
  class: "w-full text-xs text-center px-2 pt-2"
}
const _hoisted_21 = {
  key: 2,
  class: "mx-auto"
}
const _hoisted_22 = {
  key: 3,
  class: "mx-auto"
}
const _hoisted_23 = {
  key: 4,
  class: "mx-auto"
}
const _hoisted_24 = { class: "w-full text-xs text-center px-2 pt-2" }
const _hoisted_25 = { class: "w-14 mx-auto" }
const _hoisted_26 = {
  key: 0,
  class: "w-full text-xs text-center pt-2"
}
const _hoisted_27 = { class: "text-xs text-center w-full pt-1 px-2 overflow-hidden" }
const _hoisted_28 = {
  key: 1,
  class: "w-full text-xs text-center px-2 pb-3"
}
const _hoisted_29 = {
  key: 2,
  class: "w-full text-xs text-center px-2"
}
const _hoisted_30 = {
  key: 0,
  class: "h-6 flex items-center justify-center w-full"
}

import ItemImage from "@/components/itemImage.vue";
import {computed, inject, onMounted, onUnmounted, ref, watch, nextTick} from "vue";
import InfoModal from "@/components/info/infoModal.vue";
import SidebarNavigation from "@/components/sidebar/sidebarNavigation.vue";

const pageStr = "components.itemV2.itemV2VariantsList."

/**
 * image size and viewport
 */


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV2VariantsList',
  props: ["variant", "variantData", "showValues", "itemFacts"],
  emits: ["patch"],
  setup(__props) {


const props = __props;
const showValuesMaster = ref((props.showValues === true));
const showValues = ref((props.showValues === true));

const loadItemVariants = inject<any>("loadItemVariants");
const itemIdx = inject<any>("itemIdx");
const container = ref<HTMLElement | null>(null);
const isIntersecting = ref(false);

let observer: IntersectionObserver | null = null;
onMounted(() => {
  if (container.value && loadItemVariants && itemIdx) {
    observer = new IntersectionObserver((entries) => {
      isIntersecting.value = entries[0].isIntersecting;
      if (isIntersecting.value && props.variantData?.values?.length === 0 && props.variantData.idx) {
        loadItemVariants(itemIdx.value, props.variantData.idx);
      }
    }, {
      rootMargin: '400px 0px', // Start loading before it's actually visible
      threshold: 0.01
    });
    observer.observe(container.value);
  }
});

onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
});

watch(() => props.variantData?.values, (newValues) => {
  if (newValues && newValues.length === 0 && isIntersecting.value && props.variantData.idx) {
    loadItemVariants(itemIdx.value, props.variantData.idx);
  }
});


const scrollIntoViewList = ref<HTMLElement[] | null>(null);
const scrollContainer = ref<HTMLElement | null>(null);

const scrollToElement = () => {
  if (scrollIntoViewList.value) {
    const currentIdx = props.variantData.values.filter((value: { match: boolean }) => value.match)[0]?.idx || ""

    for (let selected_idx in scrollIntoViewList.value) {
      if (
          scrollIntoViewList.value[selected_idx].getAttribute("data-key") === currentIdx.toString()
      ) {
        if (typeof scrollIntoViewList.value[selected_idx].parentNode !== 'undefined') {
          const left = scrollIntoViewList.value[selected_idx].offsetLeft - scrollIntoViewList.value[selected_idx]?.parentNode?.offsetLeft - scrollIntoViewList.value[selected_idx]?.parentNode?.clientWidth / 2
          scrollIntoViewList.value[selected_idx]?.parentNode?.scrollTo({
                left: left,
                behavior: "auto"
              }
          )
        }
        break
      }
    }
  }
}

const variantValues = computed(() => {
  if (!props.variantData || !props.variantData.values) return [];
  const finaleValues = [];

  const conf_group_idx = props.variant.conf_group_idx;

  const usedSettings: string[] = [];

  for (let idx = 0; idx < props.variantData.values.length; idx++) {
    const value = props.variantData.values[idx];

    if (conf_group_idx !== "") {
      if (conf_group_idx == "model") {
        if (
            props.variant.conf_groups.setting == value.conf_groups.setting &&
            props.variant.conf_groups.size == value.conf_groups.size
        ) {
          finaleValues.push(value);
        }
      } else if (conf_group_idx == "size") {
        if (
            props.variant.conf_groups.model == value.conf_groups.model &&
            props.variant.conf_groups.setting == value.conf_groups.setting
        ) {
          finaleValues.push(value);
        }
      } else if (conf_group_idx == "setting") {
        if (
            (props.variant.conf_groups.setting == value.conf_groups.setting &&
                value.match == true) ||
            (props.variant.conf_groups.setting !== value.conf_groups.setting &&
                !usedSettings.includes(value.conf_groups.setting))
        ) {
          usedSettings.push(value.conf_groups.setting);
          finaleValues.push(value);
        }
      }
    } else {
      if (
          !(
              props.variantData.idx &&
              (
                  props.variantData.idx.includes("side_stones_id")
                  // || props.variantData.idx.includes("simple_stones") // Unbekannt warum
              ) &&
              value.used_dependencies.length > 0
          )
      ) {
        finaleValues.push(value);
      }
    }
  }

  return finaleValues;
});

watch(variantValues, () => {
  nextTick(() => {
    scrollToElement();
  });
}, { deep: true });

const firstValue = computed(() => variantValues.value[0]);

const infoModalValue = computed(() => {
  if (!firstValue.value) return ""
  if (props.variantData.idx.includes("stone_quality") && firstValue.value.additional_value) return firstValue.value.additional_value.type
  return firstValue.value && firstValue.value['idx']
})

const manualIndex = ref(0);

const currentIndex = computed({
  get: () => manualIndex.value,
  set: (val) => {
    manualIndex.value = val;
    scrollToIndex(val);
  }
});

const scrollToIndex = (index: number) => {
  const el = scrollIntoViewList.value?.[index];
  if (el) {
    el.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'center'});
  }
};

const onScroll = () => {
  if (!scrollContainer.value) return;
  const container = scrollContainer.value;
  const containerCenter = container.scrollLeft + container.clientWidth / 2;

  let closestIndex = 0;
  let minDistance = Infinity;

  scrollIntoViewList.value?.forEach((el, index) => {
    if (!el) return;
    const elCenter = el.offsetLeft + el.clientWidth / 2;
    const distance = Math.abs(elCenter - containerCenter);
    if (distance < minDistance) {
      minDistance = distance;
      closestIndex = index;
    }
  });

  manualIndex.value = closestIndex;
};

watch(() => variantValues.value, (newValues) => {
  const idx = newValues.findIndex(v => v.match);
  if (idx >= 0) {
    manualIndex.value = idx;
  }
}, {immediate: true});

const isAltActive = ref(true);
const hasAltTitle = computed(() => variantValues.value.length > 0 && !!variantValues.value[0].alt_title);
const displayTitle = (value: any) => isAltActive.value && value.alt_title ? value.alt_title : value.title;

const getCssForImageDetail = (imageType: string, idx: string, idx_value: string) => {

  const stoneSize = (idx.includes("stone_size")) ? idx_value : props.itemFacts.biggest_stone;

  let width = 14
  let height = 14
  let translateY = -42
  let translateX = -12

  if (imageType == "ring_side") {
    // no change
  } else if (imageType == "center_stone") {
    width = 14 - 0.8 * stoneSize
    height = 14 - 0.8 * stoneSize
    translateY = -12
    translateX = -39 + 0.8 * stoneSize
  } else if (imageType == "center_size") {
    width = 10 - 1.4 * stoneSize
    height = 10 - 1.4 * stoneSize
    translateY = -38 + 3 * stoneSize
    translateX = -31 + 5 * stoneSize
  } else if (imageType == "center_size_small") {
    width = 8 - 1 * stoneSize
    height = 8 - 1 * stoneSize
    translateY = -40 + 3 * stoneSize
    translateX = -30 + 3 * stoneSize
  } else if (imageType == "ring") {
    width = 6
    height = 6
    translateY = -38
    translateX = -25
  } else if (imageType == 'earring_size') {
    width = 8 - 1 * stoneSize
    height = 8 - 1 * stoneSize
    translateY = -26 + 3 * stoneSize
    translateX = -8 + 3 * stoneSize
  } else if (imageType == 'tennis-bracelet-size') {
    width = 12 - 1 * stoneSize
    height = 12 - 1 * stoneSize
    translateY = -42 + 3 * stoneSize
    translateX = -8 + 3 * stoneSize
  } else if (imageType == 'tennis-necklace-size') {
    width = 16 - 1 * stoneSize
    height = 16 - 1 * stoneSize
    translateY = -53 + 3 * stoneSize
    translateX = -8 + 3 * stoneSize
  } else if (imageType.substring(0, 6) == "style=")
    return imageType.substring(6, imageType.length)

  return "width: " + width + "rem; height: " + height + "rem; transform: translateY(" + translateY + "%) translateX(" + translateX + "%);"
}



return (_ctx: any,_cache: any) => {
  return (__props.variantData)
    ? (_openBlock(), _createElementBlock("li", {
        key: 0,
        ref_key: "container",
        ref: container,
        class: "text-sm block"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showValues.value = !showValues.value)),
            class: "grow flex items-center"
          }, [
            _createElementVNode("span", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, [
                (__props.variant.conf_groups_title)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(__props.variant.conf_groups_title[__props.variant.conf_group_idx]) + ": ", 1)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(__props.variant.group) + " " + _toDisplayString(__props.variant.title) + ": ", 1)
                    ], 64))
              ]),
              (variantValues.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(variantValues.value, (value, valueIdx) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (value.match)
                        ? (_openBlock(), _createElementBlock("span", {
                            class: "font-light text-xs",
                            key: 'match_' + valueIdx
                          }, _toDisplayString(displayTitle(value)), 1))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                : (_openBlock(), _createElementBlock("span", _hoisted_4))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(InfoModal, {
                id: __props.variantData.idx?.split('.').pop(),
                value: infoModalValue.value,
                "additional-value": firstValue.value && firstValue.value['additional_value']
              }, null, 8, ["id", "value", "additional-value"])
            ])
          ]),
          (hasAltTitle.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", {
                    class: "absolute top-0.5 bottom-0.5 bg-white rounded-md shadow-sm transition-all duration-300 ease-out transform",
                    style: _normalizeStyle({
                width: 'calc(50% - 2px)',
                left: isAltActive.value ? 'calc(50% + 1px)' : '2px'
              })
                  }, null, 4),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["relative flex-1 flex cursor-pointer items-center justify-center px-1 transition-colors duration-200 z-10 font-light", !isAltActive.value ? 'text-brand-main font-bold' : 'text-gray-500']),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (isAltActive.value = false))
                  }, _toDisplayString(_ctx.$t(pageStr + (__props.variantData.idx || '').replace(/\./g, '_') + '.off')), 3),
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["relative flex-1 flex cursor-pointer items-center justify-center px-1 transition-colors duration-200 z-10 font-light", isAltActive.value ? 'text-brand-main font-bold' : 'text-gray-500']),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (isAltActive.value = true))
                  }, _toDisplayString(_ctx.$t(pageStr + (__props.variantData.idx || '').replace(/\./g, '_') + '.on')), 3)
                ])
              ]))
            : _createCommentVNode("", true),
          (!showValuesMaster.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showValues.value = !showValues.value)),
                class: "shrink-0 ml-2 w-6 cursor-pointer text-brand-main"
              }, [
                (_openBlock(), _createElementBlock("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  class: _normalizeClass(["w-4 h-4 transition-transform duration-300", { 'rotate-180': showValues.value }]),
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M19 9l-7 7-7-7"
                  }, null, -1)
                ]))], 2))
              ]))
            : _createCommentVNode("", true)
        ]),
        (showValues.value)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              ref_key: "scrollContainer",
              ref: scrollContainer,
              onScroll: onScroll,
              class: "font-light flex mt-2 overflow-x-auto pr-10 no-scrollbar"
            }, [
              (variantValues.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(variantValues.value, (value, valueIdx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: valueIdx,
                      "data-match": value.match,
                      "data-key": value.idx,
                      ref_for: true,
                      ref_key: "scrollIntoViewList",
                      ref: scrollIntoViewList,
                      class: _normalizeClass(["text-center cursor-pointer m-1 pb-2 flex justify-center items-top", {
            'border-brand-main border-b-2':
              value.match &&
              __props.variantData.idx != 'size' &&
              __props.variantData.idx && !__props.variantData.idx.includes('stone_number') &&
              !(
                (
                typeof value.image === 'string' ||
                  typeof value.image === 'object') &&
                __props.variantData.select_option == 'image'
              ),
          }]),
                      onClick: ($event: any) => (
            _ctx.$emit('patch', {
              action: __props.variantData.idx,
              value: value.idx,
              certificated_diamond: value.certificated_diamond
            })
          )
                    }, [
                      (__props.variantData.select_option == 'image' && __props.variantData.idx != 'size')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (typeof value.image === 'string' && value.image != '' &&  __props.variantData.idx.includes('color'))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                  _createElementVNode("img", {
                                    src: value.image,
                                    class: _normalizeClass(["w-12 rounded-full mx-3", {
                'border-brand-main border-2': value.match,
              }]),
                                    title: displayTitle(value),
                                    alt: displayTitle(value)
                                  }, null, 10, _hoisted_10),
                                  _createElementVNode("p", _hoisted_11, _toDisplayString(displayTitle(value)), 1)
                                ]))
                              : (typeof value.image === 'string' && value.image != '' && __props.variantData.idx.includes('metal'))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("img", {
                                      src: value.image,
                                      class: _normalizeClass(["mx-auto w-12 h-12 overflow-hidden rounded-full", {
                'border-brand-main border-2': value.match,
              }]),
                                      title: displayTitle(value),
                                      alt: displayTitle(value)
                                    }, null, 10, _hoisted_13)
                                  ]))
                                : (typeof value.image === 'string' && value.image != '')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      _createElementVNode("img", {
                                        src: value.image,
                                        class: _normalizeClass(["w-14 rounded-full mx-3", {
                'border-brand-main border-2': value.match,
                '': !value.match,
              }]),
                                        title: displayTitle(value),
                                        alt: displayTitle(value)
                                      }, null, 10, _hoisted_15),
                                      _createElementVNode("p", _hoisted_16, _toDisplayString(displayTitle(value)), 1)
                                    ]))
                                  : (
              typeof value.image === 'object' && value.image.filename != ''
            )
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 3,
                                        class: _normalizeClass(["relative mx-auto z-20 w-20", {
              'w-20': __props.variantData.idx.includes('side_stones_id') || (__props.variantData.idx.includes('simple_stones') && !__props.variantData.idx.includes('stone_type')) || __props.variantData.idx.includes('color') || __props.variantData.idx.includes('halo_stone') || __props.variantData.idx.includes('hidden_halo_stone')
            }])
                                      }, [
                                        (typeof __props.variantData.image_type != 'undefined' && __props.variantData.image_type != '')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                              _createElementVNode("div", {
                                                class: _normalizeClass(["mx-auto w-12 h-10 overflow-hidden rounded-full", {
                'border-brand-main border-2': value.match,
                '': !value.match,
              }])
                                              }, [
                                                _createElementVNode("div", {
                                                  style: _normalizeStyle(getCssForImageDetail(__props.variantData.image_type, __props.variantData.idx, value.idx))
                                                }, [
                                                  _createVNode(ItemImage, {
                                                    "image-url": value.image.filename,
                                                    "image-layer-url": value.image.filename_layer
                                                  }, null, 8, ["image-url", "image-layer-url"])
                                                ], 4)
                                              ], 2),
                                              (__props.variantData.idx.includes('color') || __props.variantData.idx.includes('stone_size') || __props.variantData.idx.includes('stone_setting'))
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(displayTitle(value)), 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (__props.variantData.idx.includes('side_stones_id') || __props.variantData.idx.includes('simple_stones') || __props.variantData.idx.includes('color') || __props.variantData.idx.includes('metal'))
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                _createElementVNode("div", {
                                                  class: _normalizeClass(["mx-auto w-12 h-10 overflow-hidden rounded-full", {
                'border-brand-main border-2': value.match,
                '': !value.match,
              }])
                                                }, [
                                                  _createElementVNode("div", {
                                                    style: _normalizeStyle(getCssForImageDetail('ring_side', __props.variantData.idx, value.idx))
                                                  }, [
                                                    _createVNode(ItemImage, {
                                                      "image-url": value.image.filename,
                                                      "image-layer-url": value.image.filename_layer
                                                    }, null, 8, ["image-url", "image-layer-url"])
                                                  ], 4)
                                                ], 2),
                                                (__props.variantData.idx.includes('color'))
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(displayTitle(value)), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : (__props.variantData.idx.includes('halo_stone') && !__props.variantData.idx.includes('hidden_halo_stone'))
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["mx-auto w-12 h-10 overflow-hidden rounded-full", {
                'border-brand-main border-2': value.match,
                '': !value.match,
              }])
                                                  }, [
                                                    _createElementVNode("div", {
                                                      style: _normalizeStyle(getCssForImageDetail('center_size_small', __props.variantData.idx, value.idx))
                                                    }, [
                                                      _createVNode(ItemImage, {
                                                        "image-url": value.image.filename,
                                                        "image-layer-url": value.image.filename_layer
                                                      }, null, 8, ["image-url", "image-layer-url"])
                                                    ], 4)
                                                  ], 2)
                                                ]))
                                              : (__props.variantData.idx.includes('hidden_halo_stone'))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                    _createElementVNode("div", {
                                                      class: _normalizeClass(["mx-auto w-12 h-10 overflow-hidden rounded-full", {
                'border-brand-main border-2': value.match,
                '': !value.match,
              }])
                                                    }, [
                                                      _createElementVNode("div", {
                                                        style: _normalizeStyle(getCssForImageDetail('center_stone', __props.variantData.idx, value.idx))
                                                      }, [
                                                        _createVNode(ItemImage, {
                                                          "image-url": value.image.filename,
                                                          "image-layer-url": value.image.filename_layer
                                                        }, null, 8, ["image-url", "image-layer-url"])
                                                      ], 4)
                                                    ], 2)
                                                  ]))
                                                : (__props.variantData.idx.includes('stone_size'))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                                      _createElementVNode("div", {
                                                        class: _normalizeClass(["mx-auto w-16 h-14 overflow-hidden rounded-full", {
                'border-brand-main border-2 shadow-lg scale-110': value.match,
                '': !value.match,
              }])
                                                      }, [
                                                        _createElementVNode("div", {
                                                          style: _normalizeStyle(getCssForImageDetail('center_size', __props.variantData.idx, value.idx))
                                                        }, [
                                                          _createVNode(ItemImage, {
                                                            "image-url": value.image.filename,
                                                            "image-layer-url": value.image.filename_layer
                                                          }, null, 8, ["image-url", "image-layer-url"])
                                                        ], 4)
                                                      ], 2),
                                                      _createElementVNode("p", _hoisted_24, _toDisplayString(displayTitle(value)), 1)
                                                    ]))
                                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                                      _createElementVNode("div", _hoisted_25, [
                                                        _createVNode(ItemImage, {
                                                          "image-url": value.image.filename,
                                                          "image-layer-url": value.image.filename_layer,
                                                          class: _normalizeClass(["rounded-full", {
                  'mx-auto border-brand-main border overflow-hidden':
                    value.match,
                }])
                                                        }, null, 8, ["image-url", "image-layer-url", "class"])
                                                      ]),
                                                      (displayTitle(value))
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(displayTitle(value)), 1))
                                                        : _createCommentVNode("", true)
                                                    ], 64)),
                                        _createElementVNode("p", _hoisted_27, [
                                          (__props.variant.conf_group_idx !== '')
                                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                _createTextVNode(_toDisplayString(displayTitle(value)), 1)
                                              ], 64))
                                            : _createCommentVNode("", true),
                                          _createElementVNode("template", null, [
                                            _createTextVNode(_toDisplayString(displayTitle(value)), 1)
                                          ])
                                        ])
                                      ], 2))
                                    : _createCommentVNode("", true)
                          ], 64))
                        : (__props.variantData.idx == 'size' || __props.variantData.idx.includes('stone_number'))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _createElementVNode("p", {
                                class: _normalizeClass(["ring-gray-300 ring-offset-2 ring-2 rounded-full w-8 h-8 mx-auto flex items-center justify-center", {
                'border-brand-main border-2': value.match,
              }])
                              }, _toDisplayString(displayTitle(value)), 3)
                            ]))
                          : (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(displayTitle(value)), 1))
                    ], 10, _hoisted_8))
                  }), 128))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (__props.variantData.select_option == 'image' && __props.variantData.idx != 'size')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, _renderList(5, (n) => {
                          return _createElementVNode("li", {
                            key: 'skeleton_img' + n,
                            class: "m-1 pb-2 shrink-0 flex flex-col items-center w-20"
                          }, [
                            _createElementVNode("div", {
                              class: _normalizeClass([__props.variantData.idx.includes('metal') ? 'w-12 h-12' : 'w-16 h-16', "bg-gray-100 rounded-full animate-pulse mx-auto"])
                            }, null, 2),
                            (!__props.variantData.idx.includes('metal'))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [...(_cache[6] || (_cache[6] = [
                                  _createElementVNode("div", { class: "h-2 bg-gray-100 rounded animate-pulse w-10" }, null, -1)
                                ]))]))
                              : _createCommentVNode("", true)
                          ])
                        }), 64))
                      : (__props.variantData.idx == 'size' || __props.variantData.idx.includes('stone_number'))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(5, (n) => {
                            return _createElementVNode("li", {
                              key: 'skeleton_size' + n,
                              class: "m-1 pb-5 shrink-0 w-12"
                            }, [...(_cache[7] || (_cache[7] = [
                              _createElementVNode("div", { class: "w-8 h-8 bg-gray-100 rounded-full animate-pulse mx-auto" }, null, -1)
                            ]))])
                          }), 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, _renderList(5, (n) => {
                            return _createElementVNode("li", {
                              key: 'skeleton_txt' + n,
                              class: "m-1 pb-2 shrink-0 w-16"
                            }, [...(_cache[8] || (_cache[8] = [
                              _createElementVNode("div", { class: "h-4 bg-gray-100 rounded animate-pulse mx-auto w-12" }, null, -1)
                            ]))])
                          }), 64))
                  ], 64))
            ], 544))
          : _createCommentVNode("", true),
        (showValues.value)
          ? (_openBlock(), _createBlock(SidebarNavigation, {
              key: 1,
              total: variantValues.value.length,
              modelValue: currentIndex.value,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((currentIndex).value = $event)),
              container: scrollContainer.value,
              class: "mb-2 pt-0!"
            }, null, 8, ["total", "modelValue", "container"]))
          : _createCommentVNode("", true)
      ], 512))
    : _createCommentVNode("", true)
}
}

})